import { ThumbUpIcon } from "@heroicons/react/outline";
import { RiUserSmileLine } from "@remixicon/react";
import { ComponentType } from "react";

export type PlanBadgeVariant = "recommended" | "most-popular";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type IconComponent = ComponentType<{ className?: string } & any>;

interface PlanBadgeProps {
  variant: PlanBadgeVariant;
  text?: string;
  icon?: IconComponent;
}

const defaultConfig: Record<PlanBadgeVariant, { text: string; Icon: IconComponent }> = {
  recommended: {
    text: "Recommended For You",
    Icon: ThumbUpIcon,
  },
  "most-popular": {
    text: "Most Popular",
    Icon: RiUserSmileLine,
  },
};

export default function PlanBadge({ variant, text, icon: CustomIcon }: PlanBadgeProps) {
  const config = defaultConfig[variant];
  const displayText = text ?? config.text;
  const Icon = CustomIcon ?? config.Icon;

  return (
    <div className="absolute -top-[14.5px] left-1/2 -translate-x-1/2 flex h-[22px] items-center justify-center gap-1 px-1.5 bg-accent-100 dark:bg-accent-800 text-accent-800 dark:text-accent-200 text-[11px] leading-4 rounded-sm shadow whitespace-nowrap">
      <Icon className="w-3.5 h-3.5" />
      {displayText}
    </div>
  );
}
